import { request } from "../utils/request";
import { versionfn } from "../utils/version";
var version = versionfn.version;
// 手机号注册
export function phoneRegister(data) {
  return request({
    url: `/login/phone`,
    method: "post",
    data,
    skipAuth: true,
  });
}
// 登录注册——发送手机验证码(无需登录认证)
export function phoneSecurityCoderLogin(data) {
  return request({
    url: `${version}/phone/noAuth/securityCode`,
    method: "post",
    data,
    skipAuth: true,
  });
}
// 登录注册——手机找回密码
export function phoneFindPassword(data) {
  return request({
    url: `${version}/phone/retrievePassword`,
    method: "post",
    data,
    skipAuth: true,
  });
}
// 用户中心——发送手机验证码(需登录认证）
export function phoneSecurityCoderUser(data) {
  return request({
    url: `${version}/phone/auth/securityCode`,
    method: "post",
    data,
  });
}
// 用户中心——手机号绑定
export function phoneBinding(data) {
  return request({
    url: `${version}/phone/binding`,
    method: "post",
    data,
  });
}
// 用户中心——换绑手机号
export function phoneReBinding(data) {
  return request({
    url: `${version}/phone/reBinding`,
    method: "post",
    data,
  });
}
// 用户中心——旧手机号验证(换绑手机号前置接口)
export function phoneVerify(data) {
  return request({
    url: `${version}/phone/verify`,
    method: "post",
    data,
  });
}
